const PionerStake = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 375 375"
  >
    <defs>
      <symbol id="glyph0-1" data-name="glyph0-1" viewBox="0 0 52.92 63.22">
        <path
          fill="#222"
          d="M26 63.22a34.93 34.93 0 0 0 14.33-2.72 20.74 20.74 0 0 0 9.34-7.77 21.63 21.63 0 0 0 3.25-12 21.82 21.82 0 0 0-3.25-12A20.68 20.68 0 0 0 40.33 21 35.1 35.1 0 0 0 26 18.25H11.75V0H0v63.22zm-.55-35q7.68 0 11.65 3.25t4 9.31c0 4-1.32 7.13-4 9.3s-6.53 3.25-11.65 3.25h-13.7V28.17z"
        />
      </symbol>
      <symbol id="glyph0-2" data-name="glyph0-2" viewBox="0 0 54.02 63.22">
        <path
          fill="#222"
          d="M41.38 0 28.45 18.52a20.83 20.83 0 0 0-2.43-.1H11.75V0H0v63.22h26a34.93 34.93 0 0 0 14.33-2.72 20.74 20.74 0 0 0 9.34-7.77 21.63 21.63 0 0 0 3.25-12 21.44 21.44 0 0 0-3.48-12.29 20.66 20.66 0 0 0-10-7.67L54 0zm-.29 40.73c0 4-1.32 7.13-4 9.3s-6.53 3.25-11.65 3.25H11.75V28.09h13.72q7.68 0 11.65 3.3t3.97 9.34z"
        />
      </symbol>
      <symbol id="glyph0-3" data-name="glyph0-3" viewBox="0 0 59.61 65.03">
        <path
          fill="#222"
          d="M47.69 33.23H58.8V8.05a35.07 35.07 0 0 0-11.38-6A43.79 43.79 0 0 0 34.05 0a36.06 36.06 0 0 0-17.43 4.2 31.41 31.41 0 0 0-12.2 11.61A32 32 0 0 0 0 32.52a32 32 0 0 0 4.42 16.7 31.27 31.27 0 0 0 12.25 11.61A36.49 36.49 0 0 0 34.23 65a38.3 38.3 0 0 0 14.46-2.62 28.32 28.32 0 0 0 10.92-7.68l-7.41-7.2a23.72 23.72 0 0 1-17.42 7.23 24.76 24.76 0 0 1-11.89-2.79 20.4 20.4 0 0 1-8.12-7.86 22.51 22.51 0 0 1-2.94-11.56 22.21 22.21 0 0 1 2.94-11.4 21 21 0 0 1 8.12-7.93 23.85 23.85 0 0 1 11.8-2.89 25.4 25.4 0 0 1 13 3.25z"
        />
      </symbol>
      <clipPath id="clip-path">
        <path fill="none" d="M27.05 114.83h76.77v76.94H27.05z" />
      </clipPath>
      <clipPath id="clip-path-2">
        <path fill="none" d="M271.17 183.22h76.52v76.95h-76.52z" />
      </clipPath>
    </defs>
    <g id="surface1">
      <path fill="#fff" d="M0 0h375v375H0z" />
      <g clipPath="url(#clip-path)">
        <path fill="#ff66c4" d="M30.21 190.89h-3.16v-76.35h76.42v3.15H30.21z" />
      </g>
      <g clipPath="url(#clip-path-2)">
        <path fill="#ff66c4" d="M347.7 260.16h-76.42V257h73.27v-73.2h3.15z" />
      </g>
      <use
        width={52.92}
        height={63.22}
        transform="matrix(1.22 0 0 -1.22 61.91 233.73)"
        xlinkHref="#glyph0-1"
      />
      <use
        width={54.02}
        height={63.22}
        transform="matrix(1.22 0 0 -1.22 156.32 233.73)"
        xlinkHref="#glyph0-2"
      />
      <use
        width={59.61}
        height={65.03}
        transform="matrix(1.22 0 0 -1.22 245.76 234.83)"
        xlinkHref="#glyph0-3"
      />
      <use
        transform="matrix(1.22 0 0 -1.22 340.39 233.73)"
        xlinkHref="#glyph0-4"
      />
    </g>
  </svg>
);

export default PionerStake;
